import React from "react";
import { NavLink } from "react-router-dom";

export default function Footer() {
  const links = {
    "Quick Links": [
      { name: "Pakistan Stock Exchange", url: "https://www.psx.com.pk/" },
      {
        name: "Central Depository Company",
        url: "https://www.cdcpakistan.com/",
      },
      { name: "National Clearing Company", url: "https://www.nccpl.com.pk/" },
      { name: "SECP", url: "https://www.secp.gov.pk/" },
      { name: "MEDIA", url: "https://www.brecorder.com/" },
    ],
    "Client Area": [
      {
        name: "CDC Investor Account Services",
        url: "https://csp.cdcaccess.com.pk/#/login",
      },
      {
        name: "CDC IVS Services",
        url: "https://www.cdcpakistan.com/about-us/cdc-access/cdc-access-ivr/",
      },
      {
        name: "CDC SMS Services",
        url: "https://www.cdcpakistan.com/about-us/cdc-access/sms/",
      },
      { name: "NCCPL UIS Services", url: "https://uis.nccpl.com.pk/" },
      // { name: "Research", url: "#" },
      { name: "Market Watch", url: "https://www.psx.com.pk/market-summary/" },
      {
        name: "Feedback", url: "/contact-us",
      },
    ],
    "Mandatory Links": [
      {
        name: "SECP Online Complaint Link",
        url: "https://www.secp.gov.pk/for-investors/complaints/",
      },
      {
        name: "PSX Online Complaint Link",
        url: "https://www.psx.com.pk/psx/resources-and-tools/investors/investors-complaints",
      },
      {
        name: "Investor Grievances & Complaints",
        url: "/investor-complaints-queries",
      },
      {
        name: "Auditors & Legal Advisors",
        url: "/legals-associated-companies",
      },
      {
        name: "Pattern of Share Holding",
        url: "/img/Pattern-of-ShareHolding.pdf",
        nav: true
      },
      {
        name: "Other Mandatory Information",
        url: "/others-mandatory-information",
      },
    ],
  };

  const investorImages = [
    {
      src: "/img/jama-punji.jpg",
      url: "https://jamapunji.pk/",
    },
    {
      src: "/img/secppp.jpg",
      url: "https://sdms.secp.gov.pk/",
    },
    {
      src: "/img/sample.jpg",
      url: "https://cgp.cdcaccess.com.pk/cdc/cgp/r/centralized-gateway-portal/login?intermediary=YH7NAFG1YQHVE",
    },
  ];

  return (
    <footer className="footer-new">
      <div className="footer-container">
        {Object.entries(links).map(([section, items]) => (
          <div key={section} className="footer-column">
            <h2 className="footer-heading">{section}</h2>
            <ul>
              {items.map(({ name, url, nav }, index) => (
                <li key={index} className="footer-link">
                  <span className="arrow">&gt;</span>
                  {(url.startsWith("http") || nav) ? (
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-external"
                    >
                      {name}
                    </a>
                  ) : (
                    <NavLink
                      to={url}
                      className={({ isActive }) =>
                        isActive ? "active" : "footer-external"
                      }
                    >
                      {name}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/* Investor Education Section */}
        <div className="footer-column">
          <h2 className="footer-heading">Investor Education</h2>
          <div className="footer-images">
            {investorImages.map(({ src, url }, index) => (
              <a
                key={index}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={src}
                  alt={`Education ${index + 1}`}
                  className="footer-img"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
      <p className="footer-link-new">Charts powered by | <a href="https://www.tradingview.com/" rel="noreferrer" target="_blank">Tradingview</a></p>
    </footer>
  );
}
